import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { drugs } from './drugs';

export const lifestyleInsured: AnswerPathTreeNode = {
  path: 'lifestyleInsured',
  children: [drugs],
};
